"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getChart = void 0;
var _chart = require("chart.js");
var _chartjsPluginAnnotation = _interopRequireDefault(require("chartjs-plugin-annotation"));
require("chartjs-adapter-date-fns");
const getChart = () => {
  _chart.Chart.register(_chart.LineElement, _chart.PointElement, _chart.LineController, _chart.LinearScale, _chart.TimeScale, _chart.TimeSeriesScale, _chart.Decimation, _chart.Filler, _chart.Title, _chart.Tooltip, _chart.SubTitle, _chartjsPluginAnnotation.default);
  _chart.Chart.defaults.font = {
    family: 'Lato, Arial, sans-serif',
    size: 12
  };
  return _chart.Chart;
};
exports.getChart = getChart;